"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var ListingLinkForm_classNames_1 = require("./ListingLinkForm.classNames");
var ListingLinkForm_styles_1 = require("./ListingLinkForm.styles");
var TextField_1 = require("office-ui-fabric-react/lib/TextField");
var ErrorUtils_1 = require("@twii/core/lib/ErrorUtils");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Button_2 = require("office-ui-fabric-react/lib/Button");
var ListingLinkEditor = /** @class */ (function (_super) {
    __extends(ListingLinkEditor, _super);
    function ListingLinkEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onNameChanged = function (value) {
            _this.props.listingLink.setName(value);
        };
        _this._onUrlChanged = function (value) {
            _this.props.listingLink.setUrl(value);
        };
        _this._onClickRemove = function () {
            _this.props.listingLink.removeFromListing();
        };
        return _this;
    }
    ListingLinkEditor.prototype.render = function () {
        var classNames = this.props.classNames || ListingLinkForm_classNames_1.getClassNames(ListingLinkForm_styles_1.getStyles(null, this.props.styles), this.props.className);
        var inputDisabled = this.props.listingLink.listing.saveSync.syncing;
        var validationErrors = this.props.listingLink.validationErrors;
        return (React.createElement("div", { className: classNames.editor },
            React.createElement("div", { className: classNames.nameField },
                React.createElement(TextField_1.TextField, { onChanged: this._onNameChanged, value: this.props.listingLink.name || "", disabled: inputDisabled, required: true, errorMessage: ErrorUtils_1.getPropErrorMessage("name", validationErrors), placeholder: "Name" })),
            React.createElement("div", { className: classNames.urlField },
                React.createElement(TextField_1.TextField, { onChanged: this._onUrlChanged, value: this.props.listingLink.url || "", disabled: inputDisabled, required: true, errorMessage: ErrorUtils_1.getPropErrorMessage("url", validationErrors), placeholder: "URL" })),
            React.createElement("div", { className: classNames.removeAction },
                React.createElement(Button_1.IconButton, { iconProps: { iconName: "Delete" }, onClick: this._onClickRemove, title: "Remove Link" }))));
    };
    ListingLinkEditor = __decorate([
        mobx_react_1.observer
    ], ListingLinkEditor);
    return ListingLinkEditor;
}(React.Component));
exports.ListingLinkEditor = ListingLinkEditor;
var ListingLinkForm = /** @class */ (function (_super) {
    __extends(ListingLinkForm, _super);
    function ListingLinkForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onClickAdd = function () {
            _this.props.listing.addLink();
        };
        return _this;
    }
    ListingLinkForm.prototype.render = function () {
        var classNames = this.props.classNames || ListingLinkForm_classNames_1.getClassNames(ListingLinkForm_styles_1.getStyles(null, this.props.styles), this.props.className);
        var docs = this.props.listing.doc_urls;
        var content;
        if (docs && docs.length > 0) {
            var editors = docs.map(function (doc, idx) {
                return React.createElement(ListingLinkEditor, { key: idx, listingLink: doc });
            });
            content = (React.createElement("div", { className: classNames.editors }, editors));
        }
        return (React.createElement("div", { className: classNames.root },
            content,
            React.createElement("div", { className: classNames.actions },
                React.createElement(Button_2.DefaultButton, { onClick: this._onClickAdd, iconProps: { iconName: "Add" } }, "Add Link"))));
    };
    ListingLinkForm = __decorate([
        mobx_react_1.observer
    ], ListingLinkForm);
    return ListingLinkForm;
}(React.Component));
exports.ListingLinkForm = ListingLinkForm;
